/**
 * NIF-1101: copy enseñable MatchData desde keys del back → i18n journey.
 */

const KEY_ALIASES: Record<string, string> = {
	name: 'names',
	first_name: 'names',
	surname: 'surnames',
	last_name: 'surnames',
	id_document: 'identifier',
	document_number: 'identifier',
	birth_date: 'birthdate',
	zip_code: 'postal_code',
};

const DOCUMENT_NUMBER_KEYS = new Set(['identifier', 'nif', 'nie', 'cif']);

export type MatchDataErrorKeyRow = { key?: string | null };

export function uniqueMatchDataErrorKeys(errors: MatchDataErrorKeyRow[] | null | undefined): string[] {
	if (!Array.isArray(errors) || errors.length === 0) {
		return [];
	}
	const keys: string[] = [];
	for (const row of errors) {
		const raw = typeof row?.key === 'string' ? row.key : '';
		if (!raw.trim()) {
			continue;
		}
		const canonical = KEY_ALIASES[raw.trim()] ?? raw.trim();
		if (!keys.includes(canonical)) {
			keys.push(canonical);
		}
	}
	return keys;
}

export function resolveMatchDataErrorsUserMessage(
	errors: MatchDataErrorKeyRow[] | null | undefined,
	instant: (key: string, params?: Record<string, string>) => string,
): string | null {
	const keys = uniqueMatchDataErrorKeys(errors);
	if (keys.length === 0) {
		return null;
	}

	if (keys.length === 1) {
		const key = keys[0];
		const fieldKey = DOCUMENT_NUMBER_KEYS.has(key)
			? 'FINISH.MATCH_DATA_FIELD.identifier'
			: `FINISH.MATCH_DATA_FIELD.${key}`;
		const specific = instant(fieldKey);
		if (specific && specific !== fieldKey) {
			return specific;
		}
		const labelKey = `FINISH.MATCH_DATA_FIELD_LABEL.${key}`;
		const label = instant(labelKey);
		const labelText = label && label !== labelKey ? label : key;
		return instant('FINISH.MATCH_DATA_FIELD.generic', { field: labelText });
	}

	const labels = keys.map((key) => {
		const labelKey = `FINISH.MATCH_DATA_FIELD_LABEL.${key}`;
		const label = instant(labelKey);
		return label && label !== labelKey ? label : key;
	});
	return instant('FINISH.MATCH_DATA_MULTI', { fields: labels.join(', ') });
}
